import { matchingAtom } from "Global/Components/CommonComponents/GroupedView/shared/MatchingFields";
import SingleReactHookFormWrapper from "Global/Components/Generators/SingleReactHookFormWrapper/SingleReactHookFormWrapper";
import { useAtom } from "jotai";
import React, { useMemo } from "react";

const ControllerWrapper = ({ control, errors, element, field }) => {
  const [matchigFields] = useAtom(matchingAtom);
  const findmMatchingIndex = (matchigFields, field) => {
    for (let i = 0; i < matchigFields.length; i++) {
      if (matchigFields[i].iddetail === field.iddetail) {
        return i;
      }
    }
  };

  const matchingIndex = findmMatchingIndex(matchigFields, field);
  return (
    <React.Fragment>
      <SingleReactHookFormWrapper
        control={control}
        errors={errors}
        element={element}
        name={`MedicalDefaultValues[${matchingIndex}].value`}
        key={matchigFields.id}
      />
    </React.Fragment>
  );
};

export default ControllerWrapper;

// important code don't remove it !

// for (let i = 0; i < matchigFields.length; i++) {
//   if (matchigFields[i].iddetail === field.iddetail) {
//     return i;
//   } else {
//     if (matchigFields[i].iddetail === field.parentIndex) {
//       let pathStr = `MedicalDefaultValues`;
//       return pathStr.concat(
//         `[${i}].Children[${matchigFields[i].Children.findIndex(
//           (child) => child.iddetail === field.iddetail
//         )}]`
//       );
//     }
//     // If the current field has children, recursively call the function
//     if (matchigFields[i].Children) {
//       for (let j = 0; j < matchigFields[i].Children.length; j++) {
//         let result = findmMatchingIndex(matchigFields[i].Children, field);
//         if (result !== undefined) {
//           return result;
//         }
//       }
//     }
//   }
// }
